<template>
  <v-menu
    v-model="displayMenuDate"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="formattedChosenDate"
        :label="title"
        prepend-icon="event"
        color="primary"
        :rules="dateRules"
        readonly
        v-on="on"
      >
        <template v-slot:append-outer v-if="mandatory">
          <v-icon color="red" small>mdi-star-circle</v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="newDate"
      locale="fr"
      color="primary"
      @input="displayMenuDate = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DateWidget",
  props: ["date", "title", "mandatory"],
  data() {
    return {
      displayMenuDate: false,
      dateRules: this.mandatory
        ? [v => !!v || "Vous devez renseigner cette date."]
        : []
    };
  },
  computed: {
    newDate: {
      get() {
        return this.getPickerDate(this.date);
      },
      set(value) {
        this.$emit("update:date", Date.parse(value));
      }
    },
    formattedChosenDate() {
      return this.getLocalizedDate(this.date);
    }
  },
  methods: {
    getPickerDate(timestamp) {
      if (timestamp) {
        const date = new Date(timestamp);
        return (
          date.getFullYear() +
          "-" +
          this.pad(date.getMonth() + 1) +
          "-" +
          date.getDate()
        );
      }
      return null;
    },
    getLocalizedDate(timestamp) {
      if (timestamp) {
        let date = new Date(timestamp);
        return date.toLocaleDateString();
      }
      return null;
    },
    pad(s) {
      return s <= 9 ? "0" + s : "" + s;
    }
  }
};
</script>

<style></style>
